import { render, staticRenderFns } from "./LabelBadge.vue?vue&type=template&id=b9f79c68&"
import script from "./LabelBadge.vue?vue&type=script&lang=js&"
export * from "./LabelBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports